import { assetEventListReportSlice } from 'containers/accounting/asset-event-list-report-container/store'
import { isEqual } from 'lodash'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAssetEventsReport } from 'store/accounting/assetEventsReport/selectors'

export const useGetSelectedEventOnPage = (eventType?: number) => {
  const assetCollectionReportSelector = useSelector(selectAssetEventsReport, isEqual)
  const selectedList = assetEventListReportSlice.useSlice(state => state.data?.selectedItem)
  const selectedEvents = useMemo(() => {
    return assetCollectionReportSelector?.data?.data?.filter((item: any) => selectedList?.[item?.id])
  }, [selectedList, assetCollectionReportSelector, eventType])

  const selectedEventIds = selectedEvents?.map((item: any) => item?.id)

  return { selectedEvents, selectedEventIds }
}
